export const CAPACITY_TYPE_OPTIONS = [
  { value: 'POINT', label: 'Point' },
  { value: 'SEGMENT', label: 'Segment' },
];
